<template>
    <div class="detail">
        <div style="margin-top:20px">
            <a-steps :current="step - 1">
                <a-step>
                    <!-- <span slot="title">Finished</span> -->
                    <template slot="title">选择对应套餐</template>
                    <!-- <span slot="description">This is a description.</span> -->
                </a-step>
                <a-step title="客户信息补充" />
                <a-step title="订单提交" />
            </a-steps>
        </div>
        <ul class="packages" v-show="step === 1">
            <li class="package-item">
                <div class="left">
                    <div>
                        <img style="width:200px;height:120px" :src="app.logoPath" alt />
                    </div>

                    <div style="margin-left: 30px">
                        <div style="line-height: 60px;font-size:26px">{{app.applicationName}}</div>
                        <div style="line-height: 50px">{{app.productTypeLabelName}}</div>
                    </div>
                </div>
                <div class="middle">
                    <div style="margin-top: 15px; font-weight: bold">套餐设置</div>
                    <div class="select-group" style=" margin-top: 15px">
                        <div style="margin-left:40px">
                            <a-select
                                ref="selector"
                                default-value="请选择"
                                style="width: 120px"
                                @change="handleChange"
                                v-if="isSelector"
                            >
                                <a-select-option
                                    ref="packageSelector"
                                    v-for="val in packages"
                                    :key="val.id"
                                    :value="val.id"
                                >{{ val.packageVersion }}</a-select-option>
                            </a-select>
                        </div>

                        <ul style="margin-top:20px">
                            <li class="package-li" v-for="(item,index) in selectedPackages" :key="item.id">
                                <button style="width:50px;height:30px;align-self:flex-end;flex: 0 0 auto" @click="deletePackage(index)">删除</button>
                                <div>
                                    <div>套餐版本</div>
                                    <div>
                                        <a-input
                                            :value="item.packageVersion"
                                            style="width: 120px; height: 30px"
                                            placeholder
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>套餐配额</div>
                                    <div>
                                        <a-input
                                            :value="item.packageInvokeMax == -1? '无限制':item.packageInvokeMax"
                                            style="width: 120px; height: 30px"
                                            placeholder
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>价格</div>
                                    <div>
                                        <a-input
                                            :value="item.packagePrice"
                                            style="width: 120px; height: 30px"
                                            placeholder
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>使用人数</div>
                                    <div>
                                        <a-input
                                            :value="item.packageUserMax == -1? '无限制':item.packageUserMax"
                                            style="width: 120px; height: 30px"
                                            placeholder
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>使用时常</div>
                                    <div>
                                        <a-input
                                            :value="item.packageTime+getTimeUnit(item.packageTimeUnit)"
                                            style="width: 120px; height: 30px"
                                            placeholder
                                            disabled
                                        />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="right">价格：</div> -->
            </li>
        </ul>

        <div class="get-phone" v-show="step === 2">
            <div
                style="display:flex;align-items:center;justify-content:center;height:100px;margin-top:100px"
            >
                <div>
                    <span>注册商城的手机号:</span>
                    <a-input
                        v-model="phone"
                        style="width: 300px; height: 40px"
                        @input.native="handlePhoneInput"
                    ></a-input>
                    <a-button type="primary" size="large" @click="handleCheckPhone">确认</a-button>
                </div>
            </div>

            <div class="user-info" v-show="userInfo.accountId">
                <div>
                    <span>账号类型：{{ userInfo.type === 2?'企业':'个人' }}</span>

                    <span v-if="userInfo.type === 2">企业名称：{{ userInfo.enterpriseName }}</span>

                    <span>是否已实名：{{ userInfo.status === 2 ? "是" : "否" }}</span>
                </div>
            </div>
            <div class="user-info" v-show="msg">
                <div>
                    <span>找不到账号</span>
                </div>
            </div>
        </div>

        <div v-show="step === 3">
            <p style="text-align: center; margin-top: 150px">
                客户（{{phone}}）订单已提交，可在
                <span
                    style="color:blue;cursor:pointer"
                    @click="$router.push('/CustomerManage/my_customer_orders')"
                >“我的客户订单”</span>中查看，并将支付码返回给客户完成订单支付！
            </p>
        </div>

        <div class="btn-group" style="text-align:right;margin-top:50px">
            <a-button
                style="margin: 10px"
                v-show="step === 1 || step === 3"
                type="primary"
                @click="$emit('ondetail', 'List')"
            >返回</a-button>
            <a-button
                v-show="step !== 3"
                style="margin: 10px"
                type="primary"
                @click="handleNextStep"
            >
                <span>{{ step === 1 ? "下" : "上" }}</span>一步
            </a-button>
            <a-button
                :disabled="!params.accountId"
                v-show="step === 2"
                style="margin: 10px"
                type="primary"
                @click="handleSubmit"
            >提交订单</a-button>
        </div>

        <!-- <Box ref="box"/> -->
    </div>
</template>

<script>
import { message } from "ant-design-vue";
import Box from './Test'
export default {
    data() {
        return {
            packages: [],
            current: {},
            selectedPack: {},
            step: 1,
            params: {
                shareCode: "Vp74vvSGvrgyitGy",
                accountId: ""
            },
            phone: "",
            isSubmitDisabled: true,
            userInfo: {},
            msg: "",
            selectedList: [],
            isSelector:true
        };
    },
    components:{
        Box
    },
    computed: {
        selectedPackages() {
            return this.selectedList.map(id=>{
                return this.packages.find(item=>item.id === id)
            })
        }
    },
    props: {
        app: {
            type: Object
        }
    },
    methods: {
        getTimeUnit(val){
            switch(val){
                case 1:
                    return '天'
                case 2:
                    return '月'
                case 3:
                    return '年'
            }
        },
        deletePackage(idx){
            this.isSelector = false
            this.isSelector = true
            // this.$refs.selector.$forceUpdate()
            // this.$refs.pacageSelector.$forceUpdate()
            this.selectedList.splice(idx,1)
            // this.selectedList = this.selectedList.filter((item,index)=>{
            //     return index !== idx
            // })
        },
        handlePhoneInput(e) {
            if (/^\d+$/.test(e.target.value)) {
                console.log("test...");
            } else {
                e.target.value = e.target.value.substring(
                    0,
                    e.target.value.length - 1
                );
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    message.error("只允许输入数字");
                }, 1000);
            }
        },
        handleChange(value) {
            let flag = this.selectedPackages.some(item=>{
                return item.packageVersion === this.packages.find(item=>item.id === value).packageVersion
            })
            if(flag){
                this.$message.info('相同版本只能选择一个')
                return 
            }
            if (this.selectedList.includes(value)) {
                this.$message.info('不能重复选择')
                return 
            }

            this.selectedList.push(value);

            this.params.packageId = this.selectedList.toString()

            console.log(this.packages)

            console.log(this.params.packageId)
            // this.current = this.packages.find(item => item.id === value);
            // this.params.packageId = this.current.id;
        },
        handleNextStep() {
            console.log(this.selectedPack);
            if (!this.params.packageId) {
                message.error("请选择套餐版本");
                return;
            }
            this.step = this.step === 1 ? 2 : 1;
        },
        handleCheckPhone() {
            this.msg = "";
            this.userInfo = {};
            this.$api.customerManage.checkPhone(this.phone).then(res => {
                console.log(res);
                if (res.result) {
                    this.params.accountId = res.result.accountId;
                    this.userInfo = res.result;
                } else if (res.message) {
                    this.msg = res.message;
                }
            });
        },
        handleSubmit() {
            this.$api.customerManage.helpOrder(this.params).then(res => {
                console.log(res);
                this.step = 3;
            });
        }
    },
    mounted() {
        console.log(this.app);
        if (this.app.applicationId) {
            this.$api.customerManage
                .getShareCode(this.app.applicationId)
                .then(res => {
                    this.params.shareCode = res.result;
                });
            this.$api.customerManage
                .getPackageInfo(this.app.applicationId)
                .then(res => {
                    this.packages = res.result;
                });
        }

        this.params.applicationId = this.app.applicationId;
    }
};
</script>

<style scoped>
.package-li{
    display: flex;
    align-items: center;
    /* flex-shrink: 1; */
}
.packages {
    margin-top: 50px;
}
.detail {
    width: 100%;
    min-width: 800px;
    margin: 0 auto;
}
.package-item {
    display: flex;
    /* height: 50px; */
    background: #eee;
}
.package-item .left {
    width: 400px;
    flex-grow: 1;
    border-right: 1px dashed gray;
    display: flex;
    align-items: center;
    flex-shrink: 1;
}
.package-item .middle {
    width: 500px;
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 10px;
}
.package-item .right {
    width: 100px;
    flex-grow: 1;
    margin-left: 40px;
}
/* .package-item img {
    padding: 20px 5px;
    border: 1px solid #ccc;
} */
.select-group div div {
    width: 150px;
}
.user-info {
    margin-top: 100px;
    color: red;
    display: flex;
    font-size: 25px;
    justify-content: center;
}
.user-info span {
    margin-left: 50px;
}
</style>
